<i18n lang="json">
{
  "en": {
    "title": "Sell your RV",
    "heroSection": {
      "title": "Selling your RV just got easier"
    },
    "us": {
      "intro": [
        "To have your RV listed on the RVezy Marketplace, fill out the form below.",
        "RVezy has partnered with Pop, a full service for-sale-by-owner marketplace.  ",
        "We will send your contact information to Pop and they will be in touch with you to get your RV listed on the RVezy Marketplace.  The partnership is designed to provide you with additional support with selling your RV quickly and efficiently."
      ],
      "thanksForSubmitting": ["Thank you for submitting your info.", "Our partners at Pop will be in touch shortly."]
    },
    "ca": {
      "intro": [
        "To have your RV listed on the RVezy Marketplace, fill out the form below.",
        "RVezy has numerous dealership partners that can help you sell your RV.  ",
        "We will send your contact information to a relevant dealership partner and they will be in touch with you to get your RV listed on the RVezy Marketplace.  The partnership is designed to provide you with additional support with selling your RV quickly and efficiently."
      ],
      "thanksForSubmitting": ["Thank you for submitting your info.", "One of our partners will be in touch shortly."]
    },
    "contactDetails": "Contact details",
    "rvDetails": "RV details",
    "getStarted": "Get started",
    "back": "Back",
    "next": "Next 1/2",
    "submit": "Submit",
    "form": {
      "firstName": "First name",
      "lastName": "Last name",
      "phoneNumber": "Phone number",
      "emailAddress": "Email address",
      "addressUS": "Zip code",
      "addressCA": "Postal code",
      "additionalInformation": "Describe your RV",
      "price": "Asking price",
      "isInterestedInBuying": "I am interested in buying a new RV",
      "make": "Make",
      "model": "Model",
      "year": "Year",
      "rvType": "RV type"
    },
    "howItWorks": {
      "title": "How it works",
      "letUsKnow": {
        "title": "RV details - Let us know what you're selling",
        "description": "Fill the form with all the information about the RV you are selling. Once we have all your information, we will transfer it over to Pop Sells."
      },
      "popSells": {
        "title": "POP Sells will contact you",
        "description": "POP Sells will reach out to you with additional questions to help get your RV listed for sale. Once the RV is listed you will be able to see it on {link}",
        "linkDescription": "RVezy Marketplace.",
        "link": "https://marketplace.rvezy.com/en"
      },
      "popContacts": {
        "title": "Now you wait while POP finds you the perfect buyer",
        "description": "POP will now start the process to market and advertise your RV until they find you the most qualified buyer for your RV."
      },
      "offerClosing": {
        "title": "Offers & Closing",
        "description": "Receive offers for your RV from buyers in your area. Accept and close the deal."
      }
    }
  },
  "fr": {
    "title": "Vendez votre VR",
    "heroSection": {
      "title": "Achetez votre VR parfait"
    },
    "us": {
      "intro": [
        "Pour inscrire votre VR sur le RVezy Marketplace, remplissez le formulaire ci-dessous.",
        "RVezy s'est associé à Pop, un marché complet de vente par propriétaire.",
        "Nous enverrons vos coordonnées à Pop et ils vous contacteront pour inscrire votre VR sur le RVezy Marketplace.  Le partenariat est conçu pour vous fournir un soutien supplémentaire pour vendre votre VR rapidement et efficacement."
      ],
      "thanksForSubmitting": [
        "Merci d'avoir soumis vos informations.",
        "Nos partenaires chez Pop vous contacteront sous peu."
      ]
    },
    "ca": {
      "intro": [
        "Pour inscrire votre VR sur le RVezy Marketplace, remplissez le formulaire ci-dessous.",
        "RVezy a de nombreux partenaires concessionnaires qui peuvent vous aider à vendre votre VR.  ",
        "Nous enverrons vos coordonnées à un partenaire concessionnaire pertinent et ils vous contacteront pour inscrire votre VR sur le RVezy Marketplace.  Le partenariat est conçu pour vous fournir un soutien supplémentaire pour vendre votre VR rapidement et efficacement."
      ],
      "thanksForSubmitting": [
        "Merci d'avoir soumis vos informations.",
        "Un de nos partenaires vous contactera sous peu."
      ]
    },
    "contactDetails": "Détails du contact",
    "rvDetails": "Détails du VR",
    "getStarted": "Commencer",
    "back": "Retour",
    "next": "Suivant 1/2",
    "submit": "Soumettre",
    "form": {
      "firstName": "Prénom",
      "lastName": "Nom",
      "phoneNumber": "Numéro de téléphone",
      "emailAddress": "Adresse courriel",
      "addressUS": "Code postal",
      "addressCA": "Code postal",
      "additionalInformation": "Décrivez votre VR",
      "price": "Prix demandé",
      "isInterestedInBuying": "Je suis intéressé à acheter un nouveau VR",
      "make": "Marque",
      "model": "Modèle",
      "year": "Année",
      "rvType": "Type de VR"
    },
    "howItWorks": {
      "title": "Comment cela fonctionne",
      "letUsKnow": {
        "title": "Détails du VR - Faites-nous savoir ce que vous vendez",
        "description": "Remplissez le formulaire avec toutes les informations concernant le VR que vous vendez. Une fois que nous aurons reçu toutes vos informations, nous les transmettrons à Pop Sells."
      },
      "popSells": {
        "title": "POP Sells vous contactera",
        "description": "POP Sells vous contactera pour vous poser des questions supplémentaires afin de vous aider à mettre votre VR en vente. Une fois que le VR est inscrit, vous pourrez le voir sur {link}",
        "linkDescription": "RVezy Marketplace.",
        "link": "https://marketplace.rvezy.com/fr"
      },
      "popContacts": {
        "title": "Maintenant, vous attendez que POP trouve l'acheteur idéal",
        "description": "POP commencera maintenant le processus de marketing et de publicité de votre VR jusqu'à ce qu'ils trouvent l'acheteur le plus qualifié pour votre VR."
      },
      "offerClosing": {
        "title": "Offres & Clôture",
        "description": "Recevez des offres pour votre VR de la part d'acheteurs dans votre région. Acceptez et concluez l'affaire."
      }
    }
  }
}
</i18n>
<i18n lang="yaml" src="~/i18n/rv-type.yml"></i18n>

<template>
  <page-get-listed-hero-section />
  <Container
    class="pt-6 grid grid-cols-1 md:grid-cols-2 grid-rows-6 md:grid-rows-6 md:gap-y-0 gap-x-0 md:gap-x-4 relative -top-96 md:-top-[28rem] mb-[-22rem] md:mb-[-26rem]"
  >
    <!-- Hero Title -->
    <div
      :class="['max-w-full pl-4', 'pt-14 md:pt-32 lg:pt-28 md:pl-8', 'col-span-1 row-span-2 md:row-span-2 self-center']"
    >
      <img :src="`${$appConfig.cdnEndpoint}/images/pop-logo-square.png`" class="mb-3" />
      <div class="w-52 lg:w-[22.5rem]">
        <h1
          :class="[
            'mb-5 self-center text-white',
            'lg:self-start',
            {
              'typography-title-2': !isLargeScreen,
              'typography-title-5': isLargeScreen
            }
          ]"
        >
          {{ t('heroSection.title') }}
        </h1>
      </div>
    </div>

    <!-- How it works component -->
    <div class="md:order-3 col-span-1 row-span-6 md:row-span-4">
      <div class="md:max-w-xl mx-auto md:p-6">
        <h2 class="text-2xl font-bold mb-4">{{ t('howItWorks.title') }}</h2>

        <div class="space-y-2">
          <div class="flex items-start space-x-4" v-for="(howStep, index) in howItWorksSteps" :key="index">
            <div class="flex-1">
              <div
                class="flex-shrink-0 bg-transparent text-primary border-2 border-primary rounded-full outline-primary font-bold h-8 w-8 flex items-center justify-center"
              >
                {{ index + 1 }}
              </div>
              <div :class="howStep.class" class="mt-2 border-l border-primary mx-4"></div>
            </div>
            <div>
              <h3 class="text-lg font-semibold">{{ howStep.title }}</h3>
              <i18n-t v-if="index === 1" tag="p" keypath="howItWorks.popSells.description" class="pt-4">
                <template #link>
                  <a class="text-highlight underline" :href="t('howItWorks.popSells.link')">{{
                    t('howItWorks.popSells.linkDescription')
                  }}</a>
                </template>
              </i18n-t>
              <p v-else class="pt-4">{{ howStep.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Form Component -->
    <div
      :class="[
        'bg-white shadow-2xl md:shadow-xl rounded-2xl py-4 px-8 w-full',
        'max-w-96 lg:max-w-[30rem] xl:max-w-[32rem] md:mr-2',
        'col-span-1 row-span-6 md:row-span-6 place-self-center md:place-self-end'
      ]"
    >
      <h1 class="typography-title-3 mt-4 mb-6">{{ t('title') }}</h1>

      <div v-if="error" class="typography-strong-1 text-danger">
        {{ error }}
      </div>

      <template v-if="formStep === 1">
        <div class="md:max-w-96 lg:max-w-[30rem] xl:max-w-[32rem] xl:px-4">
          <label>
            <div class="typography-strong-1">{{ t('form.firstName') }}</div>
            <FormText
              autocomplete="given-name"
              v-model.trim="state.firstName"
              :error="v$.firstName.$error"
              :valid="v$.firstName.$dirty && !v$.firstName.$invalid"
              @blur="v$.firstName.$validate"
            />
          </label>

          <label>
            <div class="typography-strong-1">{{ t('form.lastName') }}</div>
            <FormText
              autocomplete="family-name"
              v-model.trim="state.lastName"
              :error="v$.lastName.$error"
              :valid="v$.lastName.$dirty && !v$.lastName.$invalid"
              @blur="v$.lastName.$validate"
            />
          </label>

          <label>
            <div class="typography-strong-1">{{ t('form.phoneNumber') }}</div>
            <FormText
              autocomplete="tel"
              v-model.trim="state.phoneNumber"
              :error="v$.phoneNumber.$error"
              :valid="v$.phoneNumber.$dirty && !v$.phoneNumber.$invalid"
              @blur="v$.phoneNumber.$validate"
            />
          </label>

          <label>
            <div class="typography-strong-1">{{ t('form.emailAddress') }}</div>
            <FormText
              type="email"
              autocomplete="email"
              v-model.trim="state.emailAddress"
              :error="v$.emailAddress.$error"
              :valid="v$.emailAddress.$dirty && !v$.emailAddress.$invalid"
              @blur="v$.emailAddress.$validate"
            />
          </label>

          <label>
            <div class="typography-strong-1">{{ addressLabel }}</div>
            <FormText
              v-model.trim="state.address"
              :error="v$.address.$error"
              :valid="v$.address.$dirty && !v$.address.$invalid"
              @blur="v$.address.$validate"
            />
          </label>
          <label>
            <div class="typography-strong-1">{{ t('form.make') }}</div>
            <FormText
              v-model="state.make"
              :error="v$.make.$error"
              :valid="v$.make.$dirty && !v$.make.$invalid"
              @blur="v$.make.$validate"
            />
          </label>
          <label>
            <div class="typography-strong-1">{{ t('form.model') }}</div>
            <FormText
              v-model="state.model"
              :error="v$.model.$error"
              :valid="v$.model.$dirty && !v$.model.$invalid"
              @blur="v$.model.$validate"
            />
          </label>
          <label>
            <div class="typography-strong-1">{{ t('form.year') }}</div>
            <FormText
              type="number"
              v-model="state.year"
              :error="v$.year.$error"
              :valid="v$.year.$dirty && !v$.year.$invalid"
              @blur="v$.year.$validate"
            />
          </label>
          <label>
            <div class="typography-strong-1">{{ t('form.rvType') }}</div>
            <FormSelect
              v-model="state.rvType"
              :error="v$.rvType.$error"
              :valid="v$.rvType.$dirty && !v$.rvType.$invalid"
              :options="rvTypeOptions"
              @blur="v$.rvType.$validate"
            />
          </label>
          <label>
            <div class="typography-strong-1">{{ t('form.price') }}</div>
            <FormText
              type="number"
              v-model="state.price"
              :error="v$.price.$error"
              :valid="v$.price.$dirty && !v$.price.$invalid"
              @blur="v$.price.$validate"
            />
          </label>
          <label>
            <div class="flex justify-between">
              <div class="typography-strong-1">{{ t('form.additionalInformation') }}</div>
              <div
                :class="{
                  'text-danger': state.additionalInformation != null && state.additionalInformation.length < 20,
                  'text-success': state.additionalInformation != null && state.additionalInformation.length >= 20
                }"
              >
                {{ state.additionalInformation?.length ?? 0 }}/1000
              </div>
            </div>
            <FormText
              multiline
              v-model.trim="state.additionalInformation"
              :error="v$.additionalInformation.$error"
              :valid="v$.additionalInformation.$dirty && !v$.additionalInformation.$invalid"
              @blur="v$.additionalInformation.$validate"
            />
          </label>

          <label class="flex flex-row items-center content-center sm:justify-center pt-4 pb-8">
            <FormCheckbox
              class="shrink mr-5"
              v-model="state.isInterestedInBuying"
              :error="v$.isInterestedInBuying.$error"
              :valid="v$.isInterestedInBuying.$dirty && !v$.isInterestedInBuying.$invalid"
              @blur="v$.isInterestedInBuying.$validate"
            />
            <div class="typography-strong-1 flex-auto">{{ t('form.isInterestedInBuying') }}</div>
          </label>

          <div class="grid grid-cols-2 gap-4">
            <FormButton class="col-start-2" variant="highlight" @click="rvDetailsSubmitHandler"
              >{{ t('submit') }}
            </FormButton>
          </div>
        </div>
      </template>

      <template v-if="formStep === 2">
        <div
          v-for="(text, key) in state.ipCountry == 'CA' ? tm('ca.thanksForSubmitting') : tm('us.thanksForSubmitting')"
          :key="key"
          class="typography-body-1"
        >
          {{ rt(text as any) }}
        </div>
      </template>
    </div>
  </Container>
</template>

<script lang="ts" setup>
definePageMeta({
  layout: 'homepage'
})

import useVuelidate from '@vuelidate/core'
import { email, maxLength, minLength, required } from '@vuelidate/validators'
import { SegmentEvents } from '~/enums/segment-events'
import { segmentTrack } from '~/lib/tracking'
import type { CountryCodes } from '~/types/api'

const { t, tm, rt } = useI18n()
const geolocation = useGeolocation()
const isLargeScreen = useIsLargeScreen()
const $appConfig = useRuntimeConfig().public.app
const { getMarketplaceApiClient } = useApiClients()

const formStep = ref(1)
const error = ref<string | null>()

const state = reactive({
  firstName: undefined,
  lastName: undefined,
  phoneNumber: undefined,
  emailAddress: undefined,
  address: undefined,
  ipCountry: (geolocation.country ?? 'XX') as CountryCodes,
  isInterestedInBuying: false,
  make: undefined,
  model: undefined,
  trim: undefined,
  rvType: undefined,
  mileage: undefined,
  price: undefined,
  year: undefined,
  additionalInformation: ''
})

const rules = {
  firstName: {
    required
  },
  lastName: {
    required
  },
  phoneNumber: {},
  emailAddress: {
    required,
    email
  },
  address: {
    required
  },
  price: {},
  additionalInformation: {
    requiredIf: required,
    minLength: minLength(20),
    maxLength: maxLength(1000)
  },
  isInterestedInBuying: {},
  make: {},
  model: {},
  year: {},
  rvType: {}
}

const addressLabel = computed(() => (state.ipCountry === 'CA' ? t('form.addressCA') : t('form.addressUS')))

const rvTypeOptions = computed(() => {
  const options: Record<string, string> = {}
  const rvTypes = tm('RVType') as Record<string, unknown>

  for (const rvType in rvTypes) {
    options[rvType] = t(`RVType.${rvType}`)
  }

  return options
})

const v$ = useVuelidate(rules, state as any)

const rvDetailsSubmitHandler = async () => {
  error.value = null

  v$.value.$reset()
  const isFormValid = await v$.value.$validate()
  if (!isFormValid) return

  try {
    await getMarketplaceApiClient().POST('/LeadSeller', {
      body: {
        additionalInformation: state.additionalInformation,
        address: state.address,
        emailAddress: state.emailAddress,
        firstName: state.firstName,
        ipCountry: state.ipCountry,
        isInterestedInBuying: state.isInterestedInBuying,
        lastName: state.lastName,
        make: state.make,
        mileage: state.mileage,
        model: state.model,
        phoneNumber: state.phoneNumber,
        price: state.price,
        rvType: state.rvType,
        trim: state.trim,
        year: state.year
      }
    })
  } catch (e: any) {
    error.value = e?.message || 'An error has occurred, please try again'
    formStep.value = 1
    return
  }

  segmentTrack(SegmentEvents.CTAClicked, {
    name: 'PrivateSellerSubmitted'
  })

  formStep.value++
  v$.value.$reset()
}
const howItWorksSteps: { title: string; description: string; class?: string }[] = [
  {
    title: t('howItWorks.letUsKnow.title'),
    description: t('howItWorks.letUsKnow.description'),
    class: 'h-32 sm:h-28 md:h-40 lg:h-24'
  },
  {
    title: t('howItWorks.popSells.title'),
    description: t('howItWorks.popSells.description'),
    class: 'h-32 lg:h-24'
  },
  {
    title: t('howItWorks.popContacts.title'),
    description: t('howItWorks.popContacts.description'),
    class: 'h-32 lg:h-30 xl:h-20'
  },
  {
    title: t('howItWorks.offerClosing.title'),
    description: t('howItWorks.offerClosing.description')
  }
]
</script>
